import {
  CapabilitiesMarketplaceResponseDataSchema,
  CapabilitiesResponseDataSchema,
  CapabilityResponseDataSchema,
} from "schema"
import z from "zod"
import { CapabilityCustomDialog } from "./CapabilityCustomDialog"

type Props<Mode extends "install" | "configure"> = {
  capability: Mode extends "install"
    ? z.infer<typeof CapabilitiesMarketplaceResponseDataSchema>[number]
    : z.infer<typeof CapabilitiesResponseDataSchema>[number]
  mode: Mode
  open?: boolean
  onOpenChange: (open: boolean) => void
  onConfigure?: (capability: z.infer<typeof CapabilityResponseDataSchema>) => void
}

export function CapabilityWebhookDialog<Mode extends "install" | "configure">({
  capability,
  mode,
  open = true,
  onOpenChange,
  onConfigure,
}: Props<Mode>) {
  return (
    <CapabilityCustomDialog
      capability={capability}
      mode={mode}
      open={open}
      onOpenChange={onOpenChange}
      onConfigure={onConfigure}
      kind="webhook"
    />
  )
}
